import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class ResumeBankService {
  // file_url = 'http://192.168.0.147:8021/api/' + 'Parsing/';
  //api_url = 'http://192.168.0.141:9005/api/' + 'ResumeReferral/';
  api_url = environment.SERVER_URL + 'ResumeReferral/';
  file_url = environment.SERVER_URL + 'Parsing/';
  constructor(
    private http: HttpClient
  ) { }

  saveDetails(requisition_id, obj) {
    return this.http.post(this.api_url + 'data', obj, { params: { requisition_id: requisition_id } });

  }
  getResume() {
    return this.http.get(this.api_url + 'ISD', { params: { lng_id: '1' } });
  }
  saveFile(file) {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    return this.http.post(this.file_url + 'XMLToJSON', file, { headers: undefined });

  }
}